import { useTheme } from '@mui/material';

import { COLORS } from '@constants/colors';
import { IStyles } from '@interfaces/styles';
import { ScreenSizes } from '@interfaces';

export const useStyles = (hasChildren: boolean): IStyles => {
  const { breakpoints } = useTheme();
  return {
    root: {
      color: COLORS.WHITE,
      borderRadius: 72,
      textTransform: 'none',
      padding: '8px 20px 8px 16px',
      fontSize: 14,
      '&:hover': {
        backgroundColor: COLORS.WHITE_1,
      },
      '& svg': {
        color: COLORS.WHITE,
        opacity: 0.5,
        mr: hasChildren ? 1 : 0,
        width: 28,
        height: 28,
      },
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '4px 10px',
        minWidth: 'unset',
        //fontSize: 14,
        '& svg': {
          width: 20,
          height: 20,
        },
      },
    },

    typography: {
      fontSize: 'inherit',
      fontWeight: 500,
      letterSpacing: '0.1px',
      lineHeight: 1.43,
      textTransform: 'capitalize',
    },
  };
};
